import React from 'react'
import { PayoutType } from './payoutTypes'
import WarningIcon from '../../../icons/WarningIcon'
interface IWarningBoxProps {
  payoutType: PayoutType
}
const WarningBox = ({ payoutType }: IWarningBoxProps): JSX.Element => {
  return (
    <div style={{
      padding: 16,
      display: 'flex',
      gap: 12,
      alignItems: 'center',
      border: `1px solid ${payoutType === PayoutType.Crypto ? '#F5D89F' : '#B8D7FF'}`,
      borderRadius: 10,
      background: payoutType === PayoutType.Crypto ? '#FEF3E7' : '#E8F2FF'
    }}>
      <div style={{ flexShrink: 0 }}>
        <WarningIcon stroke={payoutType === PayoutType.Crypto ? '#8B6914' : '#1A4D8F' } />
      </div>
      <span
        style={{
          flexShrink: 1,
          color: payoutType === PayoutType.Crypto ? '#8B6914' : '#1A4D8F',
          fontSize: 14,
          fontWeight: 300
        }}>
        {payoutType === PayoutType.Crypto ? 'Please verify the recipient address carefully. Cryptocurrency transactions cannot be reversed.' : 'SEPA payouts over €100,000 may take 1-2 business days to arrive.'}
      </span>
    </div>
  )
}

export default WarningBox
